import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DarkModeOutlined, LightModeOutlined, SettingsBrightnessOutlined } from '@mui/icons-material';
import { useThemeToggle } from '../ThemeProvider/WorkingThemeProvider';

interface SiteThemeToggleProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'inherit' | 'primary' | 'secondary' | 'default';
}

// The button cycles system → light → dark, so its icon shows the current
// preference and its tooltip names the one click lands on next.
const LABELS = {
  system: 'System theme',
  light: 'Light theme',
  dark: 'Dark theme',
} as const;

const NEXT_LABEL = {
  system: 'light',
  light: 'dark',
  dark: 'system',
} as const;

export const SiteThemeToggle: React.FC<SiteThemeToggleProps> = ({
  size = 'medium',
  color = 'inherit'
}) => {
  const { themeMode, preference, toggleTheme } = useThemeToggle();

  const icon =
    preference === 'system' ? (
      <SettingsBrightnessOutlined fontSize="small" />
    ) : preference === 'dark' ? (
      <DarkModeOutlined fontSize="small" />
    ) : (
      <LightModeOutlined fontSize="small" />
    );

  const current = preference === 'system' ? `${LABELS.system} (${themeMode})` : LABELS[preference];

  return (
    <Tooltip
      title={`${current} — switch to ${NEXT_LABEL[preference]}`}
      arrow
    >
      <IconButton
        onClick={toggleTheme}
        color={color}
        size={size}
        aria-label={`${current}. Switch to ${NEXT_LABEL[preference]} theme.`}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export default SiteThemeToggle;
